<template>
  <div id="study-status-list" class="h-full">
    <vx-card class="h-full overflow-scroll">
      <div class="flex items-center">
        <span class="text-xl mr-4">学习情况</span>
        <v-select class="w-48" v-model="selected" :options="options" />
      </div>
      <vs-divider/>
      <vs-table ref="table" pagination :max-items="8" search :data="list" :hoverFlat="true">
        <div slot="header">
          <div class="btn-group">
            <vs-button size="small" @click="getStudyStatusList(3)">全部</vs-button>
            <vs-button size="small" @click="getStudyStatusList(2)">已完成（{{ completedNum }}人）</vs-button>
            <vs-button size="small" @click="getStudyStatusList(1)">完成中（{{ learningNum }}人）</vs-button>
            <vs-button size="small" @click="getStudyStatusList(0)">未开始（{{ noStartedNum }}人）</vs-button>
          </div>
        </div>
        <template slot="thead">
          <vs-th>姓名</vs-th>
          <vs-th>视频</vs-th>
          <vs-th>课件</vs-th>
          <vs-th>任务单</vs-th>
          <vs-th>成绩记录</vs-th>
        </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p>{{ tr.name }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.video_status }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.courseware_status }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.task_status }}</p>
              </vs-td>
              <vs-td>
                <vs-button color="primary" size="small" type="filled" @click="openTemp">查看</vs-button>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>

import vSelect from 'vue-select'
import { classList, getStudentStatusByClass } from '@/api/school'

export default {
  props: {
    chapterId: {
      required: true
    },
  },
  components: {
    'v-select': vSelect,
  },
  data() {
    return {
      id: 0,
      list: [],
      options: [],
      selected: '',
      completedNum: 0,
      learningNum: 0,
      noStartedNum: 0,
    }
  },
  mounted() {
    this.id = this.chapterId
    this.getClassList()
  },
  watch: {
    selected(val) {
      this.getStudyStatusList(3)
    }
  },
  computed: {
    
  },
  methods: {
    getClassList() {
      classList().then(res => {
        if (res.code == 1) {
          res.data.list.forEach(item => {
            this.options.push({id:item.id, label:item.name})
          });
          if (this.options.length > 0) {
            this.selected = this.options[0]
          }
        }
      })
    },
    getStudyStatusList(status) {
      getStudentStatusByClass({
        class_id: this.selected.id, 
        chapter_id: this.id, 
        status: status
      }).then(res => {
        if (res.code == 1) {
          this.list = res.data.list
          this.completedNum = res.data.completed
          this.learningNum = res.data.learning
          this.noStartedNum = res.data.nostarted
        }
      })
    },
    openTemp() {
      this.$vs.dialog({
        color: 'primary',
        title: '提示',
        text: '测试任务正在研发中，暂时不可以查询成绩记录。',
        acceptText: '好的',
      })
    }
  },
  
  
}
</script>

<style lang="scss">
#study-status-list {
  white-space: nowrap;
}
</style>
